const cache = new Map<string, { data: unknown; timestamp: number }>()

const DEFAULT_TTL = 60_000 // 1 minute

export function getCached<T>(key: string, ttl = DEFAULT_TTL): T | null {
  const entry = cache.get(key)
  if (!entry) return null
  if (Date.now() - entry.timestamp > ttl) {
    cache.delete(key)
    return null
  }
  return entry.data as T
}

export function setCache(key: string, data: unknown): void {
  cache.set(key, { data, timestamp: Date.now() })
}

export function invalidateCache(prefix: string): void {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key)
  }
}

export function clearCache(): void {
  cache.clear()
}
